import PromptsTable from '@/components/Prompts/PromptsTable';

import { DEFAULT_PAGINATION_MODEL } from '../constants';

export function HomePromptsTable() {
  return (
    <PromptsTable simple={true} defaultPagination={DEFAULT_PAGINATION_MODEL} />
  );
}
